<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      :id="`input-shipping_address_city`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "ShippingCity",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('shipping_address.city')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'shipping_address.city',
      defaultLabel: this.$t("City")
    }
  }
}
</script>

<style scoped>

</style>
